// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"q5-z","subtitle":"r5-z","wrapper":"s5-z","leftArrow":"t5-z","rightArrow":"u5-z"};